import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaProfileByUser} from '../../../../../../../util/validation'
import {
  getProfile,
  getModule,
  getCompany,
  getClient,
  getSite,
  getCamp,
  saveProfileByUser,
  editProfileByUser,
} from '../../../../../services'
import {ProfileByUserModel} from '../../../../../model'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../components/UI/Select'
import {ShowSnackBar} from '../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getProflieByUserList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: ProfileByUserModel
}

const ModalAddUser: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getProflieByUserList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useCentral()
  const [module, setModule] = useState<ProfileByUserModel[] | any>([])
  const [perfil, setProfile] = useState<ProfileByUserModel[] | any>([])
  const [company, setCompany] = useState<ProfileByUserModel[] | any>([])
  const [client, setClient] = useState<ProfileByUserModel[] | any>([])
  const [site, setSite] = useState<ProfileByUserModel[] | any>([])
  const [camp, setCamp] = useState<ProfileByUserModel[] | any>([])
  const [idAll, setIdAll] = useState<string | number>('')
  const [loading, setLoading] = useState<boolean>(false)
  const {
    control,
    setValue,
    handleSubmit,
    setError,
    reset,
    formState: {errors},
  } = useForm<ProfileByUserModel>({
    resolver: yupResolver(schemaProfileByUser),
  })

  const getApplicationList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getModule({}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id || '', label: item.nombre || ''}))
      setModule(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  const getProfileList = async (id: any) => {
    try {
      const response = await getProfile({aplicacionId: id}, 1, 1000)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setProfile(mappedSites)
    } catch (error) {}
  }
  const getCompanyList = async () => {
    try {
      const response = await getCompany({isCombo: true}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      const mappedSitesFilter = [...mappedSites]
      const getAll = mappedSitesFilter.filter((item) => item.label === 'TODOS')
      if (getAll.length > 0) {
        setIdAll(getAll[0].value || '')
      }
      setCompany(mappedSites)
    } catch (error) {}
  }
  const getClientList = async (id: any, includeTodos = false) => {
    try {
      const response = await getClient({isCombo: true, companiaId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const hasAll = mappedSites.some((item) => item.value === idAll)
      if (includeTodos && idAll !== '' && !hasAll) {
        mappedSites.push({value: idAll, label: 'TODOS'})
      }
      setClient(mappedSites)
    } catch (error) {}
  }
  const getSiteList = async (id: any) => {
    try {
      const response = await getSite({isCombo: true, clienteId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const mappedSitesFilter = [...mappedSites]
      const hasAll = mappedSitesFilter.filter((item) => item.value === idAll)
      if (idAll !== '' && hasAll.length === 0) {
        mappedSites.push({value: idAll, label: 'TODOS'})
      }
      setSite(mappedSites)
    } catch (error) {}
  }
  const getCampList = async (id: any) => {
    try {
      const response = await getCamp({isCombo: true, siteId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const mappedSitesFilter = [...mappedSites]

      const hasAll = mappedSitesFilter.filter((item) => item.value === idAll)
      // if (hasAll.length === 0) {
      mappedSites.push({value: '4EsB2NAAsDA=', label: 'TODOS'})
      // }
      setCamp(mappedSites)
    } catch (error) {}
  }
  useEffect(() => {
    getApplicationList()
    getCompanyList()
  }, [])
  useEffect(() => {
    if (idPermission) {
      setValue('aplicacionId', detailpermission?.aplicacionId)
      setValue('perfilId', detailpermission?.perfilId)
      setValue('companiaId', detailpermission?.companiaId)
      setValue('clienteId', detailpermission?.clienteId)
      setValue('siteId', detailpermission?.siteId)
      setValue('campamentoId', detailpermission?.campamentoId)
      getProfileList(detailpermission?.aplicacionId)
      const isClienteTodos = detailpermission?.cliente?.toUpperCase() === 'TODOS'
      getClientList(detailpermission?.companiaId, isClienteTodos)
      getSiteList(detailpermission?.clienteId)
      getCampList(detailpermission?.siteId)
    }
  }, [idPermission])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
    setCamp([])
    setClient([])
    setSite([])
    setCamp([])
  }

  const onSubmit = async (data: ProfileByUserModel) => {
    try {
      setLoading(true)
      if (idPermission) {
        let obj = {
          id: idPermission,
          usuarioId: currentTabItem.idToEdit,
          perfilId: data.perfilId,
          siteId: data.siteId,
          campamentoId: data.campamentoId,
          clienteId: data.clienteId,
          companiaId: data.companiaId,
          aplicacionId: data.aplicacionId,
        }
        const {data: res} = await editProfileByUser(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con éxito')
          handleClose()
          getProflieByUserList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      } else {
        let obj = {
          usuarioId: currentTabItem.idToEdit,
          perfilId: data.perfilId,
          siteId: data.siteId,
          campamentoId: data.campamentoId,
          clienteId: data.clienteId,
          companiaId: data.companiaId,
          aplicacionId: data.aplicacionId,
        }

        const {data: res} = await saveProfileByUser(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con éxito')
          handleClose()
          getProflieByUserList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  const handleGetProfile = async (val: any) => {
    let value = val ? val : ''
    getProfileList(value.value)
    setValue('aplicacionId', value.value)
    setError('aplicacionId', {})
    setValue('perfilId', '')
    setError('perfilId', {})
  }
  const handleGetClient = async (val: any) => {
    let value = val ? val : ''
    setValue('companiaId', value.value)
    setError('companiaId', {})
    setValue('clienteId', '')
    setError('clienteId', {})
    setValue('siteId', '')
    setError('siteId', {})
    setValue('campamentoId', '')
    setError('campamentoId', {})
    getClientList(value.value)
  }
  const handleGetSite = async (val: any) => {
    setSite([])
    setCamp([])
    let value = val ? val : ''
    getSiteList(value.value)
    setValue('clienteId', value.value)
    setError('clienteId', {})
    setValue('siteId', '')
    setError('siteId', {})
    setValue('campamentoId', '')
    setError('campamentoId', {})
  }
  const handleGetCamp = async (val: any) => {
    let value = val ? val : ''
    setCamp([])
    getCampList(value.value)
    setValue('siteId', value.value)
    setError('siteId', {})
    setValue('campamentoId', '')
    setError('campamentoId', {})
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Permiso</h5>
          ) : (
            <h5 className='modal-title'>Agregar Permiso</h5>
          )}
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='row'>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Compañía</label>
                <Select
                  control={control}
                  name='companiaId'
                  data={company}
                  errors={errors}
                  onChangeValue={handleGetClient}
                />
              </div>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Cliente</label>
                <Select
                  control={control}
                  name='clienteId'
                  data={client}
                  errors={errors}
                  onChangeValue={handleGetSite}
                  disabled={client.length === 0}
                />
              </div>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Site</label>
                <Select
                  control={control}
                  name='siteId'
                  data={site}
                  errors={errors}
                  onChangeValue={handleGetCamp}
                  disabled={site.length === 0}
                />
              </div>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Campamento</label>
                <Select
                  control={control}
                  name='campamentoId'
                  data={camp}
                  errors={errors}
                  disabled={camp.length === 0}
                />
              </div>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Módulo</label>
                <Select
                  control={control}
                  name='aplicacionId'
                  data={module}
                  errors={errors}
                  onChangeValue={handleGetProfile}
                />
              </div>
              <div className='mb-2 col-12'>
                <label className='required form-label'>Perfil</label>
                <Select control={control} name='perfilId' data={perfil} errors={errors} />
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button
                type='submit'
                className='btn btn-primary'
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddUser}
